export function format(rawPhone, lang) {
    if (isNaN(rawPhone) || rawPhone.length < 10 || rawPhone.length > 18) {
        return '';
    }
    let phoneMask;
    let phoneExtensionMask;
    if (lang === 'fr') {
        phoneMask = '$areaCode $exchangeCode-$subscriberLine';
        phoneExtensionMask = ', poste $extension';
    }
    else {
        phoneMask = '$areaCode-$exchangeCode-$subscriberLine';
        phoneExtensionMask = ' ext. $extension';
    }
    const areaCode = rawPhone.substring(0, 3);
    const exchangeCode = rawPhone.substring(3, 6);
    const subscriberLine = rawPhone.substring(6, 10);
    const extension = rawPhone.substring(10, 18);
    let formattedPhone = phoneMask.replace('$areaCode', areaCode)
        .replace('$exchangeCode', exchangeCode)
        .replace('$subscriberLine', subscriberLine);
    if (extension !== '') {
        formattedPhone += phoneExtensionMask.replace('$extension', extension);
    }
    return formattedPhone;
}
